
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Capa_2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Social"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M20.63 17v3.5c0 .55-.45 1-1 1h-4.25v5h4.25c.55 0 1 .45 1 1v11.25h5V27.5c0-.55.45-1 1-1h4.47l1.25-5h-5.72c-.55 0-1-.45-1-1V17c0-1.52 1.23-2.75 2.75-2.75h4.25v-5h-4.25c-4.27 0-7.75 3.48-7.75 7.75z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M24 0C10.75 0 0 10.75 0 24s10.75 24 24 24 24-10.75 24-24S37.25 0 24 0zm10.63 15.25c0 .55-.45 1-1 1h-5.25c-.41 0-.75.34-.75.75v2.5h6c.31 0 .6.14.79.38.19.24.26.56.18.86l-1.75 7c-.11.45-.51.76-.97.76h-4.25v11.25c0 .55-.45 1-1 1h-7c-.55 0-1-.45-1-1V28.5h-4.25c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h4.25V17c0-5.38 4.37-9.75 9.75-9.75h5.25c.55 0 1 .45 1 1v7z"}})])])
          )
        }
      }
    